import { FC, memo, useMemo } from 'react'

import { Notification } from 'types'

import { useNotificationsManager } from 'contexts/NotificationsManager/Provider'
import markNotificationAsReaded from 'services/calls/notifications/markNotificationAsReaded'
import NotificationNewAlert from './components/NotificationNewAlert'
import NotificationNewOriginActivity from './components/NotificationNewOriginActivity'
import NotificationNewOriginPerson from './components/NotificationNewOriginPerson'

type NotificationKind = {
  [key: string]: JSX.Element
}

type Props = {
  notification: Notification
}

const NotificationCardByKind: FC<Props> = ({ notification }) => {
  const { notifications, setNotifications } = useNotificationsManager()

  async function setNotificationAsReaded() {
    const response = await markNotificationAsReaded({ notificationId: notification.id })
    console.log('markNotificationAsReaded', response)
    if (response?.header?.success) {
      const updatedNotificationFromAPI = response?.body?.notification
      console.log('updatedNotificationFromAPI', updatedNotificationFromAPI)
      const updatedNotifications = notifications.map((item) => {
        if (notification.id === item.id) return { ...notification, ...updatedNotificationFromAPI }
        return item
      })
      setNotifications(updatedNotifications)
    }
  }

  const NotificationComponentByKind = useMemo(() => {
    const notificationKinds: NotificationKind = {
      'NEW-ALERT': <NotificationNewAlert notification={notification} setNotificationAsReaded={setNotificationAsReaded} />,
      'NEW-ORIGIN-ACTIVITY': (
        <NotificationNewOriginActivity notification={notification} setNotificationAsReaded={setNotificationAsReaded} />
      ),
      'NEW-ORIGIN-PERSON': <NotificationNewOriginPerson notification={notification} setNotificationAsReaded={setNotificationAsReaded} />,
      'NEW-ATTENDANCE': <NotificationNewAlert notification={notification} setNotificationAsReaded={setNotificationAsReaded} />,
    }

    return notificationKinds[notification.kind as string]
  }, [notification])

  return NotificationComponentByKind
}

export default memo(NotificationCardByKind)
